import {DateTime} from "luxon";
import {Employee} from "./employee.entity";
import {Entity} from "./entity";
import {Issue} from "./issue.entity";
import {ProjectType} from "./project-type.entity";

export class Project extends Entity<Project> {

    constructor(type: ProjectType) {
        super();
        this._type = type;
        this._setOriginalValue(`type`, type);
    }

    private _deletedAt: DateTime | null = null;

    public get deletedAt(): DateTime | null {
        return this._deletedAt;
    }

    public set deletedAt(value: DateTime | null) {
        this._deletedAt = value;
    }

    public get isDeleted(): boolean {
        return this._deletedAt instanceof DateTime;
    }

    private _title: string = `no title`;

    public get title(): string {
        return this._title;
    }

    public set title(value: string) {
        this._title = value;
        this._setOriginalValue(`title`, value);
    }

    private _description: string = ``;

    public get description(): string {
        return this._description;
    }

    public set description(value: string) {
        this._description = value;
        this._setOriginalValue(`description`, value);
    }

    private _shortcut: string = ``;

    public get shortcut(): string {
        return this._shortcut;
    }

    public set shortcut(value: string) {
        this._shortcut = value;
        this._setOriginalValue(`shortcut`, value);
    }

    private _type: ProjectType;

    public get type(): ProjectType {
        return this._type;
    }

    public set type(value: ProjectType) {
        this._type = value;
        this._setOriginalValue(`type`, value);
    }

    private _url: string | null = null;

    public get url(): string | null {
        return this._url;
    }

    public set url(value: string | null) {
        this._url = value;
        this._setOriginalValue(`url`, value);
    }

    private _issues: Issue[] = [];

    public get issues(): Issue[] {
        return this._issues;
    }

    public set issues(value: Issue[]) {
        this._issues = value;
        this._setOriginalValue(`issues`, value);
    }

    private _creator: Employee | null = null;

    public get creator(): Employee | null {
        return this._creator;
    }

    public set creator(value: Employee | null) {
        this._creator = value;
        this._setOriginalValue(`creator`, value);
    }

    private _employees: Employee[] = [];

    public get employees(): Employee[] {
        return this._employees;
    }

    public set employees(value: Employee[]) {
        this._employees = value;
        this._setOriginalValue(`employees`, value);
    }

    private _milestones: Promise<Issue[]> = Promise.resolve([]);

    public get milestones(): Promise<Issue[]> {
        return this._milestones;
    }

    public set milestones(value: Promise<Issue[]>) {
        this._milestones = value;
        this._setOriginalValue(`milestones`, value);
    }

    private _isFixed!: boolean;

    public get isFixed(): boolean {
        return this._isFixed;
    }

    public set isFixed(value: boolean) {
        this._isFixed = value;
        this._setOriginalValue(`isFixed`, value);
    }

    public addIssue(issue: Issue): void {
        if (!this._issues.includes(issue)) {
            this._issues.push(issue);
        }
    }

    public findIssuesOfDay(date: DateTime): Issue[] {
        return this.issues
            .filter(issue => issue.interval.contains(date))
            .sort((issueA, issueB) => {
                const countA = issueA.interval.count("days");
                const countB = issueB.interval.count("days");

                if (countA === countB) {
                    return issueA.uid.localeCompare(issueB.uid);
                }

                return countB - countA;
            });
    }

    public toString(): string {
        return this.title;
    }
}